// PREMIUM GLOBAL TIMER HOOK - Single shared state across all timers
import { useState, useEffect } from 'react';

const TIMER_DURATION_MINUTES = 15;
const STORAGE_KEY = 'kaveWorkshopTimerEnd';

export const useGlobalTimer = () => {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const endTime = parseInt(saved);
      const remaining = Math.floor((endTime - Date.now()) / 1000);
      // If timer hasn't expired, return remaining time
      if (remaining > 0) {
        return remaining;
      }
      // Timer expired - return 0
      return 0;
    }
    // First visit - set end time to 15 minutes from now
    const endTime = Date.now() + TIMER_DURATION_MINUTES * 60 * 1000;
    localStorage.setItem(STORAGE_KEY, endTime.toString());
    return TIMER_DURATION_MINUTES * 60;
  });

  useEffect(() => {
    // If timer is at 0, don't start interval
    if (timeLeft <= 0) {
      return;
    }

    const timer = setInterval(() => {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const endTime = parseInt(saved);
        const remaining = Math.floor((endTime - Date.now()) / 1000);
        
        if (remaining <= 0) {
          // Timer expired - set to 0 and stop
          setTimeLeft(0);
          clearInterval(timer);
        } else {
          setTimeLeft(remaining);
        }
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const mins = Math.max(0, Math.floor(timeLeft / 60));
  const secs = Math.max(0, timeLeft % 60);

  return { 
    minutes: mins, 
    seconds: secs, 
    formatted: `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`,
    isExpired: timeLeft <= 0
  };
};
